import {Component, createEffect,createSignal,For,onCleanup,onMount,Show} from 'solid-js';
import {cleanImagePath,getOrSetAsync,toQueryString} from './API';
import {ArtworksGrid,Artwork} from './ArtworksGrid';
import { PageList } from './Controls';

type AlbumsTabProps = {
    artistId: number;
}

type Album = {
    id: number;
    name: string;
    coverImageUrl: string;
};

export const AlbumsTab : Component<AlbumsTabProps> = (props) => {
    const [albums, setAlbums] = createSignal<Album[]>([]);
    const [albumId, setAlbumId] = createSignal<number>();
    const [queryState, setQueryState] = createSignal<string>("Initiated");
    const [page, setPage] = createSignal<number>(1);
    const [pages, setPages] = createSignal<number[]>([1]);
    const [artworks, setArtworks] = createSignal<Artwork[]>([]);
    const [maxPage, setMaxPage] = createSignal<number>(1);
    
    const getAlbumsData = async () => {
        const params = { id: props.artistId };
        const json = getOrSetAsync("artist-albums/" + props.artistId, async () => {
            const response = await fetch("/Artist/GetArtistCollectionsJson?" + toQueryString(params));
            const json = await response.json();
            return json;
        });
        return json;
    };
    const getArtworksData = async (albumId: number) => {
        setQueryState("Loading");
        const params = toQueryString({
            page: page(),
            pageRows: 10,
            artistId: props.artistId,
            collectionId: albumId,
            order: "ByCollection",
            direction: "Ascending"
        });
        const json = getOrSetAsync("album-artworks/" + params, async () => {
            const response = await fetch("/Artist/SolidSearchArtworkJson?" + params);
            const json = await response.json();
            return json;
        });
        return json;
    };
    const loadAlbumArtworks = async (album: Album) => {
        setAlbumId(album.id);
        setPage(1);
        setMaxPage(1);
        await searchArtworks(true);
    };
    const searchArtworks = async (reset = false) => {
        const json = await getArtworksData(albumId() as number);
        const results = json.Data.Items.map((item: any) => {
            return {
                id: item.Id,
                backgroundColor: item.BackgroundColor,
                title: item.Title,
                alternateTitle: item.AlternateTitle,
                translateTitle: item.TranslatedTitle,
                medium: item.Medium,
                credit: item.Credit,
                content: item.Content,
                imageCount: item.ImageCount,
                measurements: item.Measurements,
                showHiresIcon: item.ShowHiresIcon,
                imageHeight: item.ImageHeight || 0,
                imageWidth: item.ImageWidth || 0,
                isForSale: item.IsForSale,
                isSold: item.IsSold,
                url: `/artworks/${item.Artist.Slug}/${item.Slug}/${item.Id}`,
                artworkLocation: !!item.ArtCollection ? {
                    id: item.ArtCollection.Id,
                    url: `/art-collections/${item.ArtCollection.Slug}/${item.ArtCollection.Id}`,
                    name: item.ArtCollection.Name,
                    details: [item.ArtCollection.City, item.ArtCollection.Country].filter(x => !!x).join(" | "),
                } : undefined,
                primaryImageUrl: item.ImageUrl,
                dateAdded: item.DateAdded,
                dateRange: item.StartYear > 0 ? item.StartYear : "",
            } as Artwork;
        }) as Artwork[];
        setMaxPage(json.Data.MaxPage);
        const _results = reset ? results : artworks().concat(results);
        setArtworks(_results);
        updatePages();
        setQueryState("Loaded");
    };
    const updatePages = () => {
        const list = [];
        for (var i = 1; i <= maxPage(); i++) list.push(i);
        setPages(list);
    };
    const searchByPageNumber = async (p: number) => {
        setPage(p);
        await searchArtworks(true);
    };
    const loadNextPageArtworks = async () => {
        console.log({ page: page(), maxPage: maxPage() });
        if (page() >= maxPage()) {
            return;
        }
        setPage(page() + 1);
        await searchArtworks(false);
    };
    const offset = 1000;
    const handleScroll = async () => {
        const scrollHeight = window.innerHeight + window.scrollY;
        const boundary = document.body.offsetHeight - offset;
        if (scrollHeight >= boundary) {
            if (queryState() != "Loading") {
                await loadNextPageArtworks();
            }
        }
    };
    createEffect(async () => {
        window.addEventListener('scroll', handleScroll);
    });
    onCleanup(async () => {
        window.removeEventListener('scroll', handleScroll);
    });
    const loadAlbums = async () => {
        const albumsJson = await getAlbumsData();
        const _albums = albumsJson.Data.map((x: any) => {
            return {
                id: x.Id,
                name: x.Name,
                coverImageUrl: x.CoverImageUrl
            } as Album;
        }) as Album[];
        setAlbums(_albums);
    }
    onMount(async () => {
        await loadAlbums();
        await loadAlbumArtworks(albums()[0]);
    });
return (
<>
    <div class="row" style="background-color: #000;">
        <div class="col-md-12">
            <div style="padding: 20px;">
                <For each={albums()}>{(album: Album) => 
                    <div style="display: inline-block; margin-right: 20px;">
                        <figure onClick={() => loadAlbumArtworks(album)}>
                            <Show when={album.coverImageUrl}>
                                <img src={ cleanImagePath(album.coverImageUrl) + "?w=200&h=200&mode=crop" } style={{ width: "200px", border: albumId() == album.id ? "solid red 2px" : 'none' }} />
                            </Show>                    
                            <figcaption>
                                <h4 style="color: #fff;">{album.name}</h4>
                            </figcaption>
                        </figure>
                    </div>
                }</For>
            </div>
        </div>
    </div>
    <div style="padding: 40px; background-color: #333;">
        <Show when={artworks().length}>
            <section class="salon-results">
                <PageList page={page} pages={pages} theme="dark" onClick={searchByPageNumber}></PageList>
                <ArtworksGrid artworks={artworks} imageBackgroundColor={"#000"}></ArtworksGrid>            
            </section>
        </Show>
    </div>
</>);
}